import { Component, EventEmitter } from '@angular/core';
import { WidgetService } from '../../widget.service';
import { Widget, WidgetTemplate } from '../../../models/widget';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-template-modal',
  templateUrl: './change-template-modal.component.html',
  styleUrls: ['./change-template-modal.component.scss']
})
export class ChangeTemplateModalComponent {
  availableTemplates: WidgetTemplate[];
  widget: Widget;
  widgetTemplateId: string;
  selectedTemplate: WidgetTemplate;
  change: EventEmitter<WidgetTemplate> = new EventEmitter<WidgetTemplate>();
  isSaving: boolean = false;

  constructor(private widgetService: WidgetService,
              public activeModal: NgbActiveModal) {
  }

  init(widget: Widget) {
    this.widget = widget;
    this.loadTemplates();
  }

  onTemplateChange(s: any) {
    this.selectedTemplate = this.availableTemplates.find(template => {
      return template.id === parseInt(this.widgetTemplateId, 10);
    });

    console.log(this.selectedTemplate);
  }

  save() {
    this.isSaving = true;
    this.widget.template = this.selectedTemplate;
    this.widgetService.update(this.widget)
      .finally(() => this.isSaving = false)
      .subscribe((widget) => {
        this.activeModal.close(widget);
      });

  }

  private loadTemplates() {
    return this.widgetService.getTemplatesForClient(this.widget.project.client).subscribe(templates => {
      this.availableTemplates = templates;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/change-template-modal/change-template-modal.component.ts